module.exports = __webpack_public_path__ + "img/mountain.1885ea1e.png";